import type { ReportKind } from "../types";

export type ReportGroupKey = "attendance" | "security" | "field";

/**
 * Markazdagi hisobot guruhlari (canvas «1 — Hisobotlar markazi»).
 *
 * ⚠️ Har kind AYNAN bir marta — `reportGroups.test.ts` `REPORT_KINDS`
 * bilan solishtiradi. Server yangi kind qo'shsa markaz uni «Boshqa»
 * guruhida baribir ko'rsatadi (`ReportGroups`), lekin qorovul qizil
 * bo'lib guruhga qo'shishni eslatadi.
 */
export const REPORT_GROUPS: { key: ReportGroupKey; kinds: ReportKind[] }[] = [
	{ key: "attendance", kinds: ["attendance_daily", "attendance_monthly", "lateness", "work_time"] },
	{ key: "security", kinds: ["zone_exits", "fake_location", "violations"] },
	{ key: "field", kinds: ["tasks", "leads"] },
];

/**
 * Qidiruv — TARJIMA QILINGAN sarlavha va tavsif bo'yicha (server matni
 * o'zbekcha, rus tilidagi foydalanuvchi esa ruscha yozadi).
 */
export function matchesReportQuery(texts: string[], query: string): boolean {
	const q = query.trim().toLocaleLowerCase();

	if (!q) {
		return true;
	}

	return texts.some((text) => text.toLocaleLowerCase().includes(q));
}
